export async function buscarCep(cep) {
  const c = String(cep || '').replace(/\D/g, '')
  if (c.length !== 8) return null
  try {
    const r = await fetch(`https://viacep.com.br/ws/${c}/json/`)
    const d = await r.json()
    if (d && !d.erro) {
      return {
        logradouro: d.logradouro || '',
        bairro:     d.bairro || '',
        cidade:     d.localidade || '',
        estado:     d.uf || '',
      }
    }
  } catch { /* silencia */ }
  return null
}
